import { testEmail, testPhoneNumber } from "./LoginHelpers";
import { APIRequest } from "../utils/http.service";

import { logAPIStatus } from "../../../api/claim";
import { postToNativeApp } from "../../../common/helpers";
import SendRequest from "../../../services/sendRequest.service";
import { TicketRequest, TicketResponse, TicketRouteEnum, TicketTypeEnum } from "../../FreshDeskTicket/ticket.dto";
import { userLoginDetails } from "../../claim/models/claimDetails.models";
// import { ILoginResponse, ISSOCheckResponse } from "./LoginModels";

export const ssoLogin = async (token: string) => {
    return await APIRequest.instance.post("/auth/sso-login", { token });
}

export const authenticateUser = (verifiedResponse) => {
    if (verifiedResponse.accessToken) {
        let det: userLoginDetails = new userLoginDetails();
        det.isLoginSkipped = false;
        det.isUserLoggedIn = true;
        det.domainName=verifiedResponse?.domainName
        localStorage.setItem('accessToken', verifiedResponse.accessToken);
        localStorage.setItem('X-REF-DATA', verifiedResponse.xRefData);
        localStorage.setItem('firstTimeLogin', verifiedResponse.isFirstLogin?.toString());
        postToNativeApp({accessToken: verifiedResponse?.accessToken || null,
            accessTokenExpirationTime: verifiedResponse?.expiry?.toString() || null,
            userDeviceToken: verifiedResponse?.deviceId,
            xRefData: verifiedResponse.xRefData
        });
    }
};


/* Ticket Creation Function */
export const createTicket = async (type:TicketTypeEnum,failureRoute:TicketRouteEnum, email: string, user: string, error: string, loginMethod: string, lsKey?:string) => {
    const url = `${process.env.REACT_APP_API_BASE_URL}/freshdesk/create/ticket?route=${failureRoute}&type=${type}`;
    const attemptCount = localStorage.getItem(`${lsKey}`) ? parseInt(localStorage.getItem(`${lsKey}`) ) : 0;
    const ticketRequest = new TicketRequest();
    ticketRequest.reason = error;
    if(loginMethod === 'USERNAME'){
        ticketRequest.mode = 'Username/password';
        ticketRequest.username = user;
    } else if(testEmail(user) || testPhoneNumber(user)) {
        ticketRequest.mode = testEmail(user) ? 'Email OTP' : 'Mobile OTP';
        ticketRequest.loginEmail = testEmail(user) ? user : undefined;
        ticketRequest.loginMobileNumber = testPhoneNumber(user) ? user : undefined;
    }
    ticketRequest.attemptCount = attemptCount;
    ticketRequest.emailForTicket = email;
    let response = new TicketResponse();
    try {
        response = await SendRequest.instance.post(url, ticketRequest);
        if(response && response.isSuccess && response.helpDeskTicket){
            localStorage.removeItem(lsKey);
        } else{
            response.isSuccess = false;
        }
    } catch (err) {
        response.isSuccess = false;
    }
    return response;
}